<template>
  <div class="mb-8 border rounded-lg bg-white p-4">
    <div class="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h3 class="text-lg font-semibold leading-tight">Full survey spreadsheet</h3>
        <div class="text-xs text-gray-500 mt-1">
          One row per registration, with graduate details, ceremony details, and every registration-backed answer.
        </div>
      </div>
      <button
        type="button"
        class="px-3 py-2 rounded text-xs border border-black bg-black text-white disabled:opacity-50 disabled:cursor-not-allowed"
        :disabled="!actions.canDownloadSurveyExport()"
        @click="actions.downloadSurveyExport()"
      >
        {{ state.surveyExportLoading ? 'Exporting...' : 'Download spreadsheet' }}
      </button>
    </div>

    <div class="mt-4 grid grid-cols-1 md:grid-cols-3 gap-3">
      <div class="rounded border bg-gray-50 p-3">
        <div class="text-xs text-gray-500">Source</div>
        <div class="text-sm font-semibold mt-1">Registration records</div>
      </div>
      <div class="rounded border bg-gray-50 p-3">
        <div class="text-xs text-gray-500">Ceremony scope</div>
        <div class="text-sm font-semibold mt-1">{{ state.surveyCeremonySelectionLabel }}</div>
      </div>
      <div class="rounded border bg-gray-50 p-3">
        <div class="text-xs text-gray-500">Columns include</div>
        <div class="text-sm font-semibold mt-1">Name, email, course/faculty fields, survey answers</div>
      </div>
    </div>

    <div v-if="state.surveyExportResult" class="mt-3 text-xs text-gray-500">
      Last export prepared {{ state.surveyExportResult.row_count }} rows with {{ (state.surveyExportResult.columns || []).length }} columns.
    </div>
    <div v-if="state.surveyExportError" class="mt-3 text-sm text-red-600">{{ state.surveyExportError }}</div>
  </div>
</template>

<script>
export default {
  name: 'SurveyExportSection',
  props: {
    state: { type: Object, required: true },
    actions: { type: Object, required: true },
  },
}
</script>
